import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62d61942"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["width", "height"]
const _hoisted_4 = ["width", "height"]
const _hoisted_5 = ["points", "strokeWidth"]
const _hoisted_6 = ["mask", "points", "strokeWidth"]
const _hoisted_7 = { class: "label-wrapper" }
const _hoisted_8 = { class: "label" }

import gsap from 'gsap'
import { onMounted, ref, computed, PropType, onUnmounted, nextTick, watch, getCurrentInstance } from 'vue'
import AudioManager, { AUDIO_ID } from '@/core/audio/AudioManager';
import { init } from 'xstate/lib/actionTypes';


enum Variation {
  Primary = 'primary',
  Secondary = 'secondary'
}

enum Color {
  Light = 'light',
  Dark = 'dark',
  DarkRed = 'dark-red'
}

enum Border {
  TL = "top-left",
  BR = "bottom-right",
  BL = "bottom-left",
}

const __default__ = {}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  variant: {
    type: String as PropType<Variation>,
    default: Variation.Primary
  },
  color: {
    type: String as PropType<Color>,
    default: Color.Light
  },
  strokeWidth: {
    type: Number,
    default: 1
  },
  borderPosition: {
    type: String as PropType<Border>
  }
},
  setup(__props) {

const props = __props



const elClass = computed(() => {
  return ['btn', `btn--${props.variant}`, `btn--${props.color}`]
})

const el = ref(null)
const maskId = ref(null)
const fillMask = ref(null)
const fillText = ref(null)
const initialText = ref(null)

const animationMouseInOver = ref(false)
const animationMouseInStarted = ref(false)
const animationMouseOutOver = ref(false)
const animationMouseOutStarted = ref(false)
const isMouseOut = ref(true)

const backgroundData = ref({ viewBox: { minX: 0, minY: 0, width: 0, height: 0 }, polygon: { points: "" } })
const shapeOpt = ref({ topLeftRatio: 0, bottomRightRatio: 0, bottomLeftRatio: 0, topRightRatio: 0 })
const borderWidth = ref(16)
const borderPosition = ref(Border.BR)

const button = ref(null)

onMounted(async () => {
  maskId.value = getCurrentInstance().uid
  if (props.variant === Variation.Secondary) {
    borderWidth.value = 10
    borderPosition.value = Border.TL
  }
  if (props.borderPosition) {
    borderPosition.value = props.borderPosition
  }

  resizeObserver.observe(button.value)
  resize()
})

onUnmounted(() => {
  resizeObserver.disconnect()
})

const getShape = ({ topLeftRatio = 0, topRightRatio = 0, bottomRightRatio = 0, bottomLeftRatio = 0 }) => {
  const elBCR = el.value.getBoundingClientRect()
  return `
      ${props.strokeWidth + (borderWidth.value * topLeftRatio)} ${props.strokeWidth}, 
      ${elBCR.width - props.strokeWidth - (borderWidth.value * topRightRatio)} ${props.strokeWidth},
      ${elBCR.width - props.strokeWidth} ${props.strokeWidth + (borderWidth.value * topRightRatio)},
      ${elBCR.width - props.strokeWidth} ${elBCR.height - props.strokeWidth * 2 - (borderWidth.value * bottomRightRatio)},
      ${elBCR.width - props.strokeWidth - (borderWidth.value * bottomRightRatio)} ${elBCR.height - props.strokeWidth * 2}, 
      ${(borderWidth.value * bottomLeftRatio) + props.strokeWidth} ${elBCR.height - props.strokeWidth * 2}, 
      ${props.strokeWidth} ${elBCR.height - props.strokeWidth * 2 - (borderWidth.value * bottomLeftRatio)}, 
      ${props.strokeWidth} ${props.strokeWidth + (borderWidth.value * topLeftRatio)} `
}

watch(() => shapeOpt, (val) => {
  backgroundData.value = {
    ...backgroundData.value,
    polygon: { points: getShape(val.value) }
  }
}, {deep: true})

watch(animationMouseInOver, () => {
  if(!isMouseOut.value) return
  if(!animationMouseOutOver.value && animationMouseInOver.value) {
    handleMouseLeave({forced: true})
  }
})

watch(isMouseOut, () => {  
  if(!isMouseOut.value) return
  if (animationMouseInOver.value && !animationMouseOutStarted.value && !animationMouseOutOver.value) {
    handleMouseLeave({forced: true})
  }
})

watch(animationMouseOutOver, () => {
  if(animationMouseOutOver.value && animationMouseInOver.value) {
    animationMouseOutOver.value = false
    animationMouseOutStarted.value = false
    animationMouseInOver.value = false
    animationMouseInStarted.value = false
  }
  
})

const resize = async () => {
  await nextTick()
  const elBCR = el.value.getBoundingClientRect()
  let points = ""
  if (borderPosition.value === Border.BR) {
    shapeOpt.value = { ...shapeOpt.value, bottomRightRatio: 1 }
  } else if (borderPosition.value === Border.TL) {
    shapeOpt.value = { ...shapeOpt.value, topLeftRatio: 1 }
  } else if (borderPosition.value === Border.BL) {
    shapeOpt.value = { ...shapeOpt.value, bottomLeftRatio: 1 }
  }
  backgroundData.value = {
    viewBox: {
      minX: 0,
      minY: 0,
      width: Math.round(elBCR.width),
      height: Math.round(elBCR.height)
    },
    polygon: {
      points
    }
  }
}
const resizeObserver = new ResizeObserver(resize)

const onClick = () => {
  if(props.variant === Variation.Secondary) {
    AudioManager.play(AUDIO_ID.UI_CLICK_Secondary)
  } else {
    AudioManager.play(AUDIO_ID.UI_CLICK_Main)
  }
}

const handleMouseEnter = () => {
  isMouseOut.value = false

  //Change Shape
  let opt = {...shapeOpt.value}
  switch (borderPosition.value) {
    case Border.BR:
      opt = {...opt, bottomRightRatio: 0, topLeftRatio: 1} 
      break;
    case Border.TL:
      opt = {...opt, bottomRightRatio: 1, topLeftRatio: 0} 
      break;
    case Border.BL:
      opt = {...opt, bottomLeftRatio: 0, topRightRatio: 1} 
      break;
    // case Border.TR:
    //   opt = {...opt, bottomLeftRatio: 1, topRightRatio: 0} 
    //   break;
    default:
      break;
  }

  const duration = 0.35
  const ease = 'power2.inOut'
  let shapeTl, textTl, maskTl

  if(props.variant === Variation.Secondary) {
    //Shape
    shapeTl = gsap.timeline()
    shapeTl.to(shapeOpt.value, {
      ...opt,
      duration,
      ease
    })

    //Mask
    maskTl = gsap.timeline()
    maskTl.to(fillMask.value, {
      scaleY: 0,
      duration: duration,
      ease: ease,
      onComplete: () => {
        gsap.set(fillMask.value, { transformOrigin: 'bottom' })
        gsap.set(fillMask.value, { translateY: '100%' })
      }
    })  
    maskTl.to(fillMask.value, {
      transformOrigin: 'bottom',
      scaleY: 1,
      duration: duration,
      clearProps: 'all',
      ease: ease,
    })

      //Text
    textTl = gsap.timeline()
    textTl.to(fillText.value, {
      'clip-path': "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
      duration: duration,
      ease,
    })
    textTl.to(fillText.value, {
      'clip-path': "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
      duration: duration,
      ease,
      clearProps: 'all'
    })
  } else if(props.variant === Variation.Primary && !animationMouseInStarted.value) {
    //Shape
    shapeTl = gsap.timeline()
    shapeTl.to(shapeOpt.value, {
      ...opt,
      duration,
      ease
    })
    shapeTl.pause()

    //Mask
    maskTl = gsap.timeline()
    maskTl.to(fillMask.value, {
      scaleY: 0,
      duration: duration,
      ease: 'power2.in',
    })
    maskTl.pause()  

    //Text
    textTl = gsap.timeline()
    textTl.to(initialText.value, {
      y: -20,
      opacity: 0,
      duration,
      ease: 'power2.in',
      onComplete: () => {
        
        gsap.set(initialText.value, { y: 0 })
        gsap.set(initialText.value, { color: button.value && getComputedStyle(button.value).getPropertyValue("--color") })
        
        gsap.set(fillText.value, { color: button.value && getComputedStyle(button.value).getPropertyValue("--mask-color-duplicated") })
        gsap.set(fillText.value, { 'clip-path': "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)" })
      },
    })
    textTl.fromTo(fillText.value, {
      y: 20,
      opacity: 0
    },{
      y: 0,
      opacity: 1,
      duration,
      ease: 'power2.out',
      onComplete: () => animationMouseInOver.value = true
    })
    textTl.pause()
  }


  if(!animationMouseOutOver.value && !animationMouseInOver.value && !animationMouseInStarted.value) {
    animationMouseInStarted.value = true
    shapeTl.resume(0)
    maskTl.resume(0)
    textTl.resume(0)
  }

  AudioManager.play(AUDIO_ID.UI_HOVER)
}

const handleMouseLeaveEvent = () => handleMouseLeave({ forced: false })

const handleMouseLeave = ({ forced = false }) => {
  
  if(!forced)
    isMouseOut.value = true

  
  let opt = {...shapeOpt.value}
  switch (borderPosition.value) {
    case Border.BR:
      opt = {...opt, bottomRightRatio: 1, topLeftRatio: 0} 
      break;
    case Border.TL:
      opt = {...opt, bottomRightRatio: 0, topLeftRatio: 1} 
      break;
    case Border.BL:
      opt = {...opt, bottomLeftRatio: 1, topRightRatio: 0} 
      break;
    // case Border.TR:
    //   opt = {...opt, bottomLeftRatio: 1, topRightRatio: 0} 
    //   break;
    default:
      break;
  }

  const duration = 0.35
  const ease = 'power2.inOut'
  let shapeTl, textTl, maskTl

  if(props.variant === Variation.Secondary) {
    //Shape
    shapeTl = gsap.timeline()
    shapeTl.to(shapeOpt.value, {
      ...opt,
      duration,
      ease
    })
  } else if(props.variant === Variation.Primary && !animationMouseOutStarted.value && animationMouseInOver.value) {
    
    //Shape
    shapeTl = gsap.timeline()
    shapeTl.to(shapeOpt.value, {
      ...opt,
      duration,
      ease
    })
    shapeTl.pause()

    //Mask
    maskTl = gsap.timeline()
    gsap.set(fillMask.value, { transformOrigin: 'bottom' })
    gsap.set(fillMask.value, { translateY: '100%' })
    maskTl.to(fillMask.value, {
      transformOrigin: 'bottom',
      scaleY: 1,
      duration: duration,
      clearProps: 'all',
      ease
    })
    maskTl.pause()

    //Text
    textTl = gsap.timeline()
    gsap.set(initialText.value, { opacity: 1 })
    textTl.to(fillText.value, {
      'clip-path': "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
      duration: duration,
      ease,
      clearProps: 'all',
      onComplete: () => {
        animationMouseOutOver.value = true
        initialText.value?.setAttribute('style', '')
      }
    })
    textTl.pause()
  }
  

  if(!animationMouseOutStarted.value && animationMouseInOver.value && !animationMouseOutOver.value) {    
    animationMouseOutStarted.value = true
    shapeTl.resume(0)
    maskTl.resume(0)
    textTl.resume(0)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    ref_key: "button",
    ref: button,
    onMouseleave: handleMouseLeaveEvent,
    onMouseenter: handleMouseEnter,
    onClick: onClick,
    class: _normalizeClass(_unref(elClass))
  }, [
    _createElementVNode("span", {
      ref_key: "el",
      ref: el,
      class: "background"
    }, [
      (_openBlock(), _createElementBlock("svg", {
        viewBox: `${backgroundData.value.viewBox.minX} ${backgroundData.value.viewBox.minY} ${backgroundData.value.viewBox.width} ${backgroundData.value.viewBox.height}`,
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("defs", null, [
          _createElementVNode("mask", { id: maskId.value }, [
            _createElementVNode("rect", {
              x: 0,
              y: 0,
              width: backgroundData.value.viewBox.width,
              height: backgroundData.value.viewBox.height,
              fill: "white"
            }, null, 8, _hoisted_3),
            _createElementVNode("rect", {
              ref_key: "fillMask",
              ref: fillMask,
              x: 0,
              y: 0,
              width: Math.max(backgroundData.value.viewBox.width, 0),
              height: Math.max(backgroundData.value.viewBox.height, 0),
              fill: "black"
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_2)
        ]),
        _createElementVNode("polygon", {
          points: backgroundData.value.polygon.points,
          fill: "none",
          strokeWidth: __props.strokeWidth
        }, null, 8, _hoisted_5),
        _createElementVNode("polygon", {
          mask: `url(#${maskId.value})`,
          class: "hover-shape",
          points: backgroundData.value.polygon.points,
          strokeWidth: __props.strokeWidth
        }, null, 8, _hoisted_6)
      ], 8, _hoisted_1))
    ], 512),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", {
        ref_key: "initialText",
        ref: initialText,
        class: "label"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 512)
    ]),
    _createElementVNode("div", {
      ref_key: "fillText",
      ref: fillText,
      class: "label-wrapper label-wrapper-hover"
    }, [
      _createElementVNode("span", _hoisted_8, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 512)
  ], 34))
}
}

})